// extracted by mini-css-extract-plugin
module.exports = {"form":"EmailForm_form__V8FxP","logo":"EmailForm_logo__1SrPP","inputs":"EmailForm_inputs__3ZaOv"};